// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"85290289","453":"eda0bf86","455":"cc4c5021"}[chunkId] + ".chunk.js";
};